
import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';

// Interfaces
import ICountedOption from '@/ship/Models/ICountedOption';

// Enums

@Component({
    components: {},
})
export default class PMCountedTabs extends Vue {
    @Ref()
    slider!: HTMLDivElement;
    @VModel({ type: [Object, Boolean, String, Number, Array], default: null })
    selected!: ICountedOption['value'];
    @Prop({ type: Array, default: () => [] })
    options!: ICountedOption[];
    @Prop({ type: Boolean, default: true })
    spacedAround!: boolean;
    @Prop({ type: Boolean, default: false })
    isShownCount!: boolean;
    @Prop({ type: Boolean, default: false })
    isCreateStructure!: boolean;

    moveSlider() {
        const activeTab = this.$el.querySelector('.v-counted-tabs__tab--active') as HTMLDivElement;

        if (this.slider && activeTab) {
            this.slider.style.width = `${activeTab.clientWidth}px`;
            this.slider.style.left = `${activeTab.offsetLeft}px`;
        }
    }

    public selectValue(option: ICountedOption) {
        // if (!this.isCreateStructure || value === PMTabTypeEnum.chartInfo || value === PMTabTypeEnum.structure) {
        //     this.selected = value;
        // } else {
        //     this.$modal.show(ModalEnum.Alert, {
        //         title: 'Невозможно перейти в раздел',
        //         description: 'Чтобы перейти в данный раздел, создайте структуру графика',
        //         hideCloseIcon: false,
        //         actionLabel: this.$t('clear'),
        //     });
        // }

        this.selected = option.value;
        this.$router.push({ name: option.value, params: option.routerParams || {} });
    }

    @Watch('selected')
    @Watch('options', { deep: true })
    public sliderPositionChangeHandler() {
        this.$nextTick(() => this.moveSlider());
    }

    mounted() {
        setTimeout(() => this.moveSlider(), 100);
    }
}
